/* eslint-disable react/jsx-props-no-spreading */
import { SocialIconProps } from './types';

const Vungle = ({ dimension, ...props }: SocialIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 218 272"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        fill="#c7f1f0"
        d="M 57.5,38.5 C 50.1667,38.5 42.8333,38.5 35.5,38.5C 34.8334,31.3225 34.1667,23.9891 33.5,16.5C 31.4684,15.181 29.4684,15.181 27.5,16.5C 28.1522,15.2749 29.3189,14.6083 31,14.5C 32.4357,14.5589 33.769,14.8922 35,15.5C 35.4997,22.8258 35.6663,30.1591 35.5,37.5C 43.0191,37.175 50.3524,37.5084 57.5,38.5 Z"
      />
    </g>
    <g>
      <path
        fill="#d3f4f3"
        d="M 27.5,37.5 C 20.1667,38.1667 12.8333,38.8333 5.5,39.5C 4.53862,41.2646 4.20528,43.2646 4.5,45.5C 3.27493,44.8478 2.60826,43.6811 2.5,42C 2.67516,40.3419 3.34183,39.0086 4.5,38C 12.1594,37.5003 19.8261,37.3336 27.5,37.5 Z"
      />
    </g>
    <g>
      <path
        fill="#34d0cc"
        d="M 35.5,38.5 C 42.3134,39.4912 49.3134,39.8245 56.5,39.5C 56.5,41.1667 56.5,42.8333 56.5,44.5C 48.8261,44.3336 41.1594,44.5003 33.5,45C 32.5192,52.4129 32.1858,59.9129 32.5,67.5C 31.1667,67.5 29.8333,67.5 28.5,67.5C 28.825,59.9809 28.4916,52.6476 27.5,45.5C 20.3524,44.5084 13.0191,44.175 5.5,44.5C 5.5,42.8333 5.5,41.1667 5.5,39.5C 12.8333,38.8333 20.1667,38.1667 27.5,37.5C 27.5,30.5 27.5,23.5 27.5,16.5C 29.4684,15.181 31.4684,15.181 33.5,16.5C 34.1667,23.9891 34.8334,31.3225 35.5,38.5 Z"
      />
    </g>
    <g>
      <path
        fill="#7be2df"
        d="M 5.5,39.5 C 5.5,41.1667 5.5,42.8333 5.5,44.5C 13.0191,44.175 20.3524,44.5084 27.5,45.5C 19.8333,45.5 12.1667,45.5 4.5,45.5C 4.20528,43.2646 4.53862,41.2646 5.5,39.5 Z"
      />
    </g>
    <g>
      <path
        fill="#6bdedb"
        d="M 35.5,38.5 C 42.8333,38.5 50.1667,38.5 57.5,38.5C 57.8016,41.0593 57.4682,43.3926 56.5,45.5C 48.9809,45.175 41.6476,45.5084 34.5,46.5C 33.8333,53.5 33.1667,60.5 32.5,67.5C 32.1858,59.9129 32.5192,52.4129 33.5,45C 41.1594,44.5003 48.8261,44.3336 56.5,44.5C 56.5,42.8333 56.5,41.1667 56.5,39.5C 49.3134,39.8245 42.3134,39.4912 35.5,38.5 Z"
      />
    </g>
    <g>
      <path
        fill="#c8f1f0"
        d="M 56.5,45.5 C 49.6866,46.4912 42.6866,46.8245 35.5,46.5C 35.8245,53.6866 35.4912,60.6866 34.5,67.5C 34.5,60.5 34.5,53.5 34.5,46.5C 41.6476,45.5084 48.9809,45.175 56.5,45.5 Z"
      />
    </g>
    <g>
      <path
        fill="#8be5e3"
        d="M 27.5,45.5 C 28.4916,52.6476 28.825,59.9809 28.5,67.5C 29.8333,67.5 31.1667,67.5 32.5,67.5C 33.1667,60.5 33.8333,53.5 34.5,46.5C 34.5,53.5 34.5,60.5 34.5,67.5C 32.3926,68.4682 30.0593,68.8016 27.5,68.5C 27.5,60.8333 27.5,53.1667 27.5,45.5 Z"
      />
    </g>
    <g>
      <path
        fill="#1ccdc8"
        d="M 211.5,45.5 C 210.833,48.5 210.167,51.5 209.5,54.5C 207.35,55.8154 206.016,57.8154 205.5,60.5C 204.526,62.7427 204.192,65.076 204.5,67.5C 204.5,67.8333 204.5,68.1667 204.5,68.5C 203.153,67.9717 201.819,67.805 200.5,68C 201.517,71.7725 201.517,75.6059 200.5,79.5C 198.81,84.1784 197.143,88.8451 195.5,93.5C 194.414,93.62 193.747,94.2867 193.5,95.5C 192.533,97.7617 191.866,100.095 191.5,102.5C 190.373,107.217 189.039,111.883 187.5,116.5C 186.559,118.05 185.893,119.716 185.5,121.5C 183.62,123.755 182.62,126.422 182.5,129.5C 181.326,130.514 180.66,131.847 180.5,133.5C 179.361,136.004 178.694,138.67 178.5,141.5C 178.5,141.833 178.5,142.167 178.5,142.5C 176.415,144.684 175.415,147.351 175.5,150.5C 174.414,150.62 173.747,151.287 173.5,152.5C 172.287,156.607 170.953,160.607 169.5,164.5C 169.5,165.167 169.5,165.833 169.5,166.5C 168.326,167.514 167.66,168.847 167.5,170.5C 165.275,175.173 163.609,180.173 162.5,185.5C 161.326,186.514 160.66,187.847 160.5,189.5C 159.508,191.456 158.508,193.456 157.5,195.5C 156.545,197.746 155.878,200.079 155.5,202.5C 155.5,203.167 155.5,203.833 155.5,204.5C 154.326,205.514 153.66,206.847 153.5,208.5C 153.5,209.5 153.5,210.5 153.5,211.5C 152.026,212.436 151.026,213.77 150.5,215.5C 147.983,218.615 146.649,222.282 146.5,226.5C 146.122,228.921 145.455,231.254 144.5,233.5C 144.5,234.167 144.5,234.833 144.5,235.5C 143.167,236.167 142.167,237.167 141.5,238.5C 129.167,238.5 116.833,238.5 104.5,238.5C 104.5,237.5 104.5,236.5 104.5,235.5C 104.232,233.901 104.566,232.568 105.5,231.5C 106.5,231.167 107.167,230.5 107.5,229.5C 109.926,225.195 111.593,220.528 112.5,215.5C 112.629,213.784 112.962,212.117 113.5,210.5C 113.232,208.901 113.566,207.568 114.5,206.5C 115.5,206.167 116.167,205.5 116.5,204.5C 118.926,200.195 120.593,195.528 121.5,190.5C 121.629,188.784 121.962,187.117 122.5,185.5C 123.434,184.432 123.768,183.099 123.5,181.5C 124.906,181.027 125.573,180.027 125.5,178.5C 125.5,177.5 125.5,176.5 125.5,175.5C 127.759,174.656 128.759,172.989 128.5,170.5C 129.5,170.5 130.5,170.5 131.5,170.5C 132.677,164.128 134.01,157.795 135.5,151.5C 137.12,148.772 138.12,145.772 138.5,142.5C 138.394,139.921 139.061,137.588 140.5,135.5C 141.201,133.412 142.201,131.412 143.5,129.5C 145.942,124.055 147.942,118.388 149.5,112.5C 151.357,110.718 152.357,108.385 152.5,105.5C 153.407,103.343 154.073,101.01 154.5,98.5C 154.5,98.1667 154.5,97.8333 154.5,97.5C 155.537,96.0697 156.204,94.403 156.5,92.5C 156.232,90.901 156.566,89.5676 157.5,88.5C 158.906,88.0269 159.573,87.0269 159.5,85.5C 159.5,84.1667 159.5,82.8333 159.5,81.5C 160.833,81.5 161.5,80.8333 161.5,79.5C 163.294,77.5718 164.294,75.2384 164.5,72.5C 165.449,70.2627 166.116,67.9294 166.5,65.5C 166.5,64.8333 166.5,64.1667 166.5,63.5C 167.906,63.0269 168.573,62.0269 168.5,60.5C 170.986,55.8148 172.653,50.8148 173.5,45.5C 186.167,44.1667 198.833,44.1667 211.5,45.5 Z"
      />
    </g>
    <g>
      <path
        fill="#91e6e4"
        d="M 211.5,45.5 C 212.613,46.9464 212.78,48.6131 212,50.5C 211.066,51.8584 210.232,53.1917 209.5,54.5C 210.167,51.5 210.833,48.5 211.5,45.5 Z"
      />
    </g>
    <g>
      <path
        fill="#83e2e0"
        d="M 173.5,45.5 C 172.653,50.8148 170.986,55.8148 168.5,60.5C 169.431,55.1707 171.098,50.1707 173.5,45.5 Z"
      />
    </g>
    <g>
      <path
        fill="#5ed9d6"
        d="M 209.5,54.5 C 209.371,56.2161 209.038,57.8828 208.5,59.5C 207.617,62.3855 206.284,65.0521 204.5,67.5C 204.192,65.076 204.526,62.7427 205.5,60.5C 206.016,57.8154 207.35,55.8154 209.5,54.5 Z"
      />
    </g>
    <g>
      <path
        fill="#a6e9e7"
        d="M 168.5,60.5 C 168.573,62.0269 167.906,63.0269 166.5,63.5C 166.427,61.9731 167.094,60.9731 168.5,60.5 Z"
      />
    </g>
    <g>
      <path
        fill="#cdf2f0"
        d="M 78.5,67.5 C 73.8333,67.5 69.1667,67.5 64.5,67.5C 66.3972,66.1952 68.7305,65.5286 71.5,65.5C 74.2695,65.5286 76.6028,66.1952 78.5,67.5 Z"
      />
    </g>
    <g>
      <path
        fill="#75e0dd"
        d="M 64.5,67.5 C 69.1667,67.5 73.8333,67.5 78.5,67.5C 79.1667,67.5 79.8333,67.5 80.5,67.5C 80.5,67.8333 80.5,68.1667 80.5,68.5C 73.7756,68.2441 67.109,68.5774 60.5,69.5C 61.287,67.8958 62.6203,67.2291 64.5,67.5 Z"
      />
    </g>
    <g>
      <path
        fill="#58d7d4"
        d="M 204.5,68.5 C 203.699,70.0418 203.366,71.7085 203.5,73.5C 202.27,75.2972 201.604,77.2972 201.5,79.5C 201.167,79.5 200.833,79.5 200.5,79.5C 201.517,75.6059 201.517,71.7725 200.5,68C 201.819,67.805 203.153,67.9717 204.5,68.5 Z"
      />
    </g>
    <g>
      <path
        fill="#aaecea"
        d="M 60.5,69.5 C 59.3285,70.3446 57.9952,71.0113 56.5,71.5C 57.1834,69.8235 58.5168,69.1568 60.5,69.5 Z"
      />
    </g>
    <g>
      <path
        fill="#c8f2f0"
        d="M 80.5,68.5 C 80.5,68.1667 80.5,67.8333 80.5,67.5C 83.6393,67.5988 85.9726,68.9321 87.5,71.5C 85.0554,70.6876 82.7221,69.6876 80.5,68.5 Z"
      />
    </g>
    <g>
      <path
        fill="#aaeae9"
        d="M 166.5,65.5 C 166.116,67.9294 165.449,70.2627 164.5,72.5C 164.167,72.5 163.833,72.5 163.5,72.5C 163.182,69.5185 164.182,67.1852 166.5,65.5 Z"
      />
    </g>
    <g>
      <path
        fill="#1bcdc8"
        d="M 80.5,68.5 C 82.7221,69.6876 85.0554,70.6876 87.5,71.5C 92.0291,74.3612 95.0291,78.3612 96.5,83.5C 97.0688,86.4492 97.4021,89.4492 97.5,92.5C 96.8239,97.1883 96.1573,101.855 95.5,106.5C 94.8902,107.391 94.5569,108.391 94.5,109.5C 91.8333,111.5 89.5,113.833 87.5,116.5C 85.9731,116.427 84.9731,117.094 84.5,118.5C 83.8333,118.5 83.1667,118.5 82.5,118.5C 81.1667,118.833 79.8333,119.167 78.5,119.5C 70.618,120.345 63.2847,119.011 56.5,115.5C 53.1609,114.81 51.1609,112.81 50.5,109.5C 50.0679,108.29 49.4013,107.29 48.5,106.5C 48.573,104.973 47.9063,103.973 46.5,103.5C 45.5655,102.432 45.2322,101.099 45.5,99.5C 45.5,95.1667 45.5,90.8333 45.5,86.5C 46.4918,84.5439 47.4918,82.5439 48.5,80.5C 49.9063,80.0269 50.573,79.0269 50.5,77.5C 52.5,75.5 54.5,73.5 56.5,71.5C 57.9952,71.0113 59.3285,70.3446 60.5,69.5C 67.109,68.5774 73.7756,68.2441 80.5,68.5 Z"
      />
    </g>
    <g>
      <path
        fill="#def7f6"
        d="M 208.5,59.5 C 208.345,63.6287 207.512,67.6287 206,71.5C 205.292,72.3805 204.458,73.0472 203.5,73.5C 203.366,71.7085 203.699,70.0418 204.5,68.5C 204.5,68.1667 204.5,67.8333 204.5,67.5C 206.284,65.0521 207.617,62.3855 208.5,59.5 Z"
      />
    </g>
    <g>
      <path
        fill="#aeebe9"
        d="M 56.5,71.5 C 54.5,73.5 52.5,75.5 50.5,77.5C 51.1667,74.1667 53.1667,72.1667 56.5,71.5 Z"
      />
    </g>
    <g>
      <path
        fill="#91e5e3"
        d="M 50.5,77.5 C 50.573,79.0269 49.9063,80.0269 48.5,80.5C 48.427,78.9731 49.0937,77.9731 50.5,77.5 Z"
      />
    </g>
    <g>
      <path
        fill="#7ee1de"
        d="M 163.5,72.5 C 163.833,72.5 164.167,72.5 164.5,72.5C 164.294,75.2384 163.294,77.5718 161.5,79.5C 161.5,79.1667 161.5,78.8333 161.5,78.5C 161.704,76.3146 162.37,74.3146 163.5,72.5 Z"
      />
    </g>
    <g>
      <path
        fill="#c9f1f0"
        d="M 161.5,78.5 C 161.5,78.8333 161.5,79.1667 161.5,79.5C 161.5,80.8333 160.833,81.5 159.5,81.5C 159.285,79.8212 159.952,78.8212 161.5,78.5 Z"
      />
    </g>
    <g>
      <path
        fill="#b8eeec"
        d="M 48.5,80.5 C 47.4918,82.5439 46.4918,84.5439 45.5,86.5C 45.0246,83.6874 46.0246,81.6874 48.5,80.5 Z"
      />
    </g>
    <g>
      <path
        fill="#d1f4f3"
        d="M 200.5,79.5 C 200.833,79.5 201.167,79.5 201.5,79.5C 200.065,85.1688 198.565,90.8355 197,96.5C 196.329,97.2524 195.496,97.5858 194.5,97.5C 194.433,96.0413 194.766,94.7079 195.5,93.5C 197.143,88.8451 198.81,84.1784 200.5,79.5 Z"
      />
    </g>
    <g>
      <path
        fill="#a2e8e6"
        d="M 159.5,85.5 C 159.573,87.0269 158.906,88.0269 157.5,88.5C 157.427,86.9731 158.094,85.9731 159.5,85.5 Z"
      />
    </g>
    <g>
      <path
        fill="#5bdad7"
        d="M 96.5,83.5 C 96.8333,83.5 97.1667,83.5 97.5,83.5C 98.4491,88.7401 98.7825,94.0735 98.5,99.5C 97.3657,101.839 96.3657,104.173 95.5,106.5C 96.1573,101.855 96.8239,97.1883 97.5,92.5C 97.4021,89.4492 97.0688,86.4492 96.5,83.5 Z"
      />
    </g>
    <g>
      <path
        fill="#cdf2f0"
        d="M 45.5,86.5 C 45.5,90.8333 45.5,95.1667 45.5,99.5C 44.1999,97.777 43.5332,95.6103 43.5,93C 43.5332,90.3897 44.1999,88.223 45.5,86.5 Z"
      />
    </g>
    <g>
      <path
        fill="#b5efed"
        d="M 97.5,83.5 C 99.4461,88.3958 100.113,93.7291 99.5,99.5C 99.1667,99.5 98.8333,99.5 98.5,99.5C 98.7825,94.0735 98.4491,88.7401 97.5,83.5 Z"
      />
    </g>
    <g>
      <path
        fill="#afecea"
        d="M 156.5,92.5 C 156.204,94.403 155.537,96.0697 154.5,97.5C 154.12,95.302 154.787,93.6354 156.5,92.5 Z"
      />
    </g>
    <g>
      <path
        fill="#6fdedb"
        d="M 195.5,93.5 C 194.766,94.7079 194.433,96.0413 194.5,97.5C 193.559,99.0495 192.893,100.716 192.5,102.5C 192.167,102.5 191.833,102.5 191.5,102.5C 191.866,100.095 192.533,97.7617 193.5,95.5C 193.747,94.2867 194.414,93.62 195.5,93.5 Z"
      />
    </g>
    <g>
      <path
        fill="#84e3e0"
        d="M 154.5,98.5 C 154.073,101.01 153.407,103.343 152.5,105.5C 152.338,103.473 152.505,101.473 153,99.5C 153.383,98.944 153.883,98.6107 154.5,98.5 Z"
      />
    </g>
    <g>
      <path
        fill="#97e6e3"
        d="M 46.5,103.5 C 47.9063,103.973 48.573,104.973 48.5,106.5C 47.0937,106.027 46.427,105.027 46.5,103.5 Z"
      />
    </g>
    <g>
      <path
        fill="#8ee4e2"
        d="M 48.5,106.5 C 49.4013,107.29 50.0679,108.29 50.5,109.5C 48.9519,109.179 48.2852,108.179 48.5,106.5 Z"
      />
    </g>
    <g>
      <path
        fill="#dcf6f5"
        d="M 98.5,99.5 C 98.8333,99.5 99.1667,99.5 99.5,99.5C 99.3094,102.983 98.6427,106.316 97.5,109.5C 96.5,109.5 95.5,109.5 94.5,109.5C 94.5569,108.391 94.8902,107.391 95.5,106.5C 96.3657,104.173 97.3657,101.839 98.5,99.5 Z"
      />
    </g>
    <g>
      <path
        fill="#69dcd9"
        d="M 152.5,105.5 C 152.357,108.385 151.357,110.718 149.5,112.5C 149.5,111.833 149.5,111.167 149.5,110.5C 150.065,108.58 151.065,106.913 152.5,105.5 Z"
      />
    </g>
    <g>
      <path
        fill="#c8f2f1"
        d="M 149.5,110.5 C 149.5,111.167 149.5,111.833 149.5,112.5C 148.833,113.5 148.167,114.5 147.5,115.5C 147.12,113.302 147.787,111.635 149.5,110.5 Z"
      />
    </g>
    <g>
      <path
        fill="#c8f2f1"
        d="M 94.5,109.5 C 94.719,110.675 94.3857,111.675 93.5,112.5C 91.8669,114.503 89.8669,115.836 87.5,116.5C 89.5,113.833 91.8333,111.5 94.5,109.5 Z"
      />
    </g>
    <g>
      <path
        fill="#caf2f1"
        d="M 191.5,102.5 C 191.833,102.5 192.167,102.5 192.5,102.5C 192.662,104.527 192.495,106.527 192,108.5C 190.768,111.412 189.268,114.078 187.5,116.5C 189.039,111.883 190.373,107.217 191.5,102.5 Z"
      />
    </g>
    <g>
      <path
        fill="#c4f0ee"
        d="M 87.5,116.5 C 87.0269,117.906 86.0269,118.573 84.5,118.5C 84.9731,117.094 85.9731,116.427 87.5,116.5 Z"
      />
    </g>
    <g>
      <path
        fill="#dff7f6"
        d="M 56.5,116.5 C 59.2938,118.213 62.2938,119.546 65.5,120.5C 65.5,120.833 65.5,121.167 65.5,121.5C 61.3477,121.597 58.3477,119.931 56.5,116.5 Z"
      />
    </g>
    <g>
      <path
        fill="#64dcd8"
        d="M 56.5,116.5 C 56.5,116.167 56.5,115.833 56.5,115.5C 63.2847,119.011 70.618,120.345 78.5,119.5C 74.3656,120.485 70.0323,120.818 65.5,120.5C 62.2938,119.546 59.2938,118.213 56.5,116.5 Z"
      />
    </g>
    <g>
      <path
        fill="#bff0ef"
        d="M 82.5,118.5 C 82.0472,119.458 81.3805,120.292 80.5,121C 75.5111,121.499 70.5111,121.666 65.5,121.5C 65.5,121.167 65.5,120.833 65.5,120.5C 70.0323,120.818 74.3656,120.485 78.5,119.5C 79.8333,119.167 81.1667,118.833 82.5,118.5 Z"
      />
    </g>
    <g>
      <path
        fill="#8ce4e2"
        d="M 149.5,112.5 C 147.942,118.388 145.942,124.055 143.5,129.5C 143.5,128.5 143.5,127.5 143.5,126.5C 144.68,122.784 146.013,119.117 147.5,115.5C 148.167,114.5 148.833,113.5 149.5,112.5 Z"
      />
    </g>
    <g>
      <path
        fill="#c3f0ef"
        d="M 119.5,126.5 C 117.5,125.167 115.5,125.167 113.5,126.5C 113.97,125.307 114.97,124.64 116.5,124.5C 118.03,124.64 119.03,125.307 119.5,126.5 Z"
      />
    </g>
    <g>
      <path
        fill="#d9f6f4"
        d="M 101.5,129.5 C 99.7378,127.583 97.5712,126.25 95,125.5C 92.6974,126.743 92.1974,128.409 93.5,130.5C 90.0767,129.551 89.7434,127.884 92.5,125.5C 97.0676,123.649 100.068,124.982 101.5,129.5 Z"
      />
    </g>
    <g>
      <path
        fill="#aaebea"
        d="M 185.5,121.5 C 185.306,124.33 184.639,126.996 183.5,129.5C 183.167,129.5 182.833,129.5 182.5,129.5C 182.62,126.422 183.62,123.755 185.5,121.5 Z"
      />
    </g>
    <g>
      <path
        fill="#d7f5f4"
        d="M 143.5,126.5 C 143.5,127.5 143.5,128.5 143.5,129.5C 142.201,131.412 141.201,133.412 140.5,135.5C 140.049,131.896 141.049,128.896 143.5,126.5 Z"
      />
    </g>
    <g>
      <path
        fill="#79dfdc"
        d="M 119.5,126.5 C 119.5,127.5 119.5,128.5 119.5,129.5C 119.167,129.5 118.833,129.5 118.5,129.5C 117.796,127.656 116.463,127.156 114.5,128C 112.5,130 110.5,132 108.5,134C 106.613,134.78 104.946,134.613 103.5,133.5C 105.698,133.88 107.365,133.213 108.5,131.5C 110.5,130.167 112.167,128.5 113.5,126.5C 115.5,125.167 117.5,125.167 119.5,126.5 Z"
      />
    </g>
    <g>
      <path
        fill="#9ce7e4"
        d="M 182.5,129.5 C 182.771,131.38 182.104,132.713 180.5,133.5C 180.66,131.847 181.326,130.514 182.5,129.5 Z"
      />
    </g>
    <g>
      <path
        fill="#dbf5f5"
        d="M 118.5,129.5 C 118.833,129.5 119.167,129.5 119.5,129.5C 117.944,132.736 115.944,135.736 113.5,138.5C 115.944,141.264 117.944,144.264 119.5,147.5C 116.833,145.167 114.167,142.833 111.5,140.5C 111.433,139.041 111.766,137.708 112.5,136.5C 114.5,134.167 116.5,131.833 118.5,129.5 Z"
      />
    </g>
    <g>
      <path
        fill="#99e5e3"
        d="M 112.5,136.5 C 111.766,137.708 111.433,139.041 111.5,140.5C 110.876,140.083 110.543,139.416 110.5,138.5C 110.747,137.287 111.414,136.62 112.5,136.5 Z"
      />
    </g>
    <g>
      <path
        fill="#d3f4f3"
        d="M 182.5,129.5 C 182.833,129.5 183.167,129.5 183.5,129.5C 183.657,130.873 183.49,132.207 183,133.5C 181.768,136.412 180.268,139.078 178.5,141.5C 178.694,138.67 179.361,136.004 180.5,133.5C 182.104,132.713 182.771,131.38 182.5,129.5 Z"
      />
    </g>
    <g>
      <path
        fill="#39d1cd"
        d="M 101.5,129.5 C 101.5,129.833 101.5,130.167 101.5,130.5C 102.551,131.222 103.218,132.222 103.5,133.5C 104.946,134.613 106.613,134.78 108.5,134C 110.5,132 112.5,130 114.5,128C 116.463,127.156 117.796,127.656 118.5,129.5C 116.5,131.833 114.5,134.167 112.5,136.5C 111.414,136.62 110.747,137.287 110.5,138.5C 110.543,139.416 110.876,140.083 111.5,140.5C 114.167,142.833 116.833,145.167 119.5,147.5C 119.5,148.5 119.5,149.5 119.5,150.5C 117.958,151.301 116.292,151.634 114.5,151.5C 113.833,150.167 112.833,149.167 111.5,148.5C 110.032,146.502 108.199,144.835 106,143.5C 104.699,143.639 103.866,144.305 103.5,145.5C 101.548,146.785 99.8818,148.451 98.5,150.5C 93.994,151.146 93.3273,149.479 96.5,145.5C 97.1667,144.5 97.8333,143.5 98.5,142.5C 99.5817,141.406 100.248,140.073 100.5,138.5C 98.8602,135.196 96.5269,132.529 93.5,130.5C 92.1974,128.409 92.6974,126.743 95,125.5C 97.5712,126.25 99.7378,127.583 101.5,129.5 Z"
      />
    </g>
    <g>
      <path
        fill="#d9f5f4"
        d="M 101.5,130.5 C 103.451,130.227 104.951,130.893 106,132.5C 106.671,131.748 107.504,131.414 108.5,131.5C 107.365,133.213 105.698,133.88 103.5,133.5C 103.218,132.222 102.551,131.222 101.5,130.5 Z"
      />
    </g>
    <g>
      <path
        fill="#b0ecea"
        d="M 98.5,142.5 C 97.8333,143.5 97.1667,144.5 96.5,145.5C 95.391,145.557 94.391,145.89 93.5,146.5C 94.5387,144.469 96.2054,143.136 98.5,142.5 Z"
      />
    </g>
    <g>
      <path
        fill="#d7f5f4"
        d="M 111.5,148.5 C 109.245,147.785 107.412,146.452 106,144.5C 105.329,145.252 104.496,145.586 103.5,145.5C 103.866,144.305 104.699,143.639 106,143.5C 108.199,144.835 110.032,146.502 111.5,148.5 Z"
      />
    </g>
    <g>
      <path
        fill="#daf6f5"
        d="M 178.5,142.5 C 178.982,145.831 177.982,148.497 175.5,150.5C 175.415,147.351 176.415,144.684 178.5,142.5 Z"
      />
    </g>
    <g>
      <path
        fill="#b4ecea"
        d="M 93.5,147.5 C 92.1667,148.5 92.1667,149.5 93.5,150.5C 90.8333,149.5 90.8333,148.5 93.5,147.5 Z"
      />
    </g>
    <g>
      <path
        fill="#74dfdb"
        d="M 96.5,145.5 C 93.3273,149.479 93.994,151.146 98.5,150.5C 97.3646,152.213 95.698,152.88 93.5,152.5C 93.5,151.833 93.5,151.167 93.5,150.5C 92.1667,149.5 92.1667,148.5 93.5,147.5C 93.5,147.167 93.5,146.833 93.5,146.5C 94.391,145.89 95.391,145.557 96.5,145.5 Z"
      />
    </g>
    <g>
      <path
        fill="#92e5e3"
        d="M 138.5,142.5 C 138.12,145.772 137.12,148.772 135.5,151.5C 135.167,151.5 134.833,151.5 134.5,151.5C 135.056,148.063 136.389,145.063 138.5,142.5 Z"
      />
    </g>
    <g>
      <path
        fill="#a6e9e7"
        d="M 119.5,150.5 C 119.209,151.649 118.376,152.316 117,152.5C 115.93,152.472 115.097,152.139 114.5,151.5C 115.097,152.139 115.93,152.472 117,152.5C 118.376,152.316 119.209,151.649 119.5,150.5 Z"
      />
    </g>
    <g>
      <path
        fill="#ddf6f6"
        d="M 103.5,145.5 C 102.134,148.064 100.467,150.564 98.5,153C 96.6131,153.78 94.9464,153.613 93.5,152.5C 95.698,152.88 97.3646,152.213 98.5,150.5C 99.8818,148.451 101.548,146.785 103.5,145.5 Z"
      />
    </g>
    <g>
      <path
        fill="#bff0ee"
        d="M 134.5,151.5 C 133.921,154.706 132.921,157.706 131.5,160.5C 131.145,156.923 132.145,153.923 134.5,151.5 Z"
      />
    </g>
    <g>
      <path
        fill="#c9f2f0"
        d="M 175.5,150.5 C 175.579,156.198 173.579,160.865 169.5,164.5C 170.953,160.607 172.287,156.607 173.5,152.5C 173.747,151.287 174.414,150.62 175.5,150.5 Z"
      />
    </g>
    <g>
      <path
        fill="#ccf2f1"
        d="M 68.5,158.5 C 75.5079,158.334 82.5079,158.5 89.5,159C 90.8333,166.667 90.8333,174.333 89.5,182C 82.5079,182.5 75.5079,182.666 68.5,182.5C 67.8902,181.609 67.5569,180.609 67.5,179.5C 66.3467,173.347 66.18,167.014 67,160.5C 67.7172,159.956 68.2172,159.289 68.5,158.5 Z"
      />
    </g>
    <g>
      <path
        fill="#88e1de"
        d="M 69.5,160.5 C 75.3188,159.347 81.3188,159.181 87.5,160C 88.056,160.383 88.3893,160.883 88.5,161.5C 88.8229,167.69 88.4896,173.69 87.5,179.5C 87.8229,173.31 87.4896,167.31 86.5,161.5C 81.0247,160.511 75.358,160.178 69.5,160.5 Z"
      />
    </g>
    <g>
      <path
        fill="#ecfaf9"
        d="M 68.5,158.5 C 68.2172,159.289 67.7172,159.956 67,160.5C 66.18,167.014 66.3467,173.347 67.5,179.5C 67.5569,180.609 67.8902,181.609 68.5,182.5C 67.5041,182.586 66.6708,182.252 66,181.5C 65.3333,174.167 65.3333,166.833 66,159.5C 66.6708,158.748 67.5041,158.414 68.5,158.5 Z"
      />
    </g>
    <g>
      <path
        fill="#4dd6d3"
        d="M 134.5,151.5 C 134.833,151.5 135.167,151.5 135.5,151.5C 134.01,157.795 132.677,164.128 131.5,170.5C 130.5,170.5 129.5,170.5 128.5,170.5C 129.11,169.609 129.443,168.609 129.5,167.5C 129.5,166.833 129.5,166.167 129.5,165.5C 130.537,164.07 131.204,162.403 131.5,160.5C 132.921,157.706 133.921,154.706 134.5,151.5 Z"
      />
    </g>
    <g>
      <path
        fill="#bdefed"
        d="M 131.5,160.5 C 131.204,162.403 130.537,164.07 129.5,165.5C 129.12,163.302 129.787,161.635 131.5,160.5 Z"
      />
    </g>
    <g>
      <path
        fill="#63dad7"
        d="M 69.5,160.5 C 75.358,160.178 81.0247,160.511 86.5,161.5C 80.8333,161.5 75.1667,161.5 69.5,161.5C 69.5,167.5 69.5,173.5 69.5,179.5C 75.5,179.5 81.5,179.5 87.5,179.5C 81.69,180.49 75.69,180.823 69.5,180.5C 68.8333,180.167 68.1667,179.833 67.5,179.5C 67.3338,173.491 67.5005,167.491 68,161.5C 68.3826,160.944 68.8826,160.611 69.5,160.5 Z"
      />
    </g>
    <g>
      <path
        fill="#12ccc7"
        d="M 86.5,161.5 C 87.4896,167.31 87.8229,173.31 87.5,179.5C 81.5,179.5 75.5,179.5 69.5,179.5C 69.5,173.5 69.5,167.5 69.5,161.5C 75.1667,161.5 80.8333,161.5 86.5,161.5 Z"
      />
    </g>
    <g>
      <path
        fill="#c3f0ee"
        d="M 169.5,166.5 C 169.843,168.483 169.176,169.817 167.5,170.5C 167.66,168.847 168.326,167.514 169.5,166.5 Z"
      />
    </g>
    <g>
      <path
        fill="#8ce4e1"
        d="M 129.5,167.5 C 129.443,168.609 129.11,169.609 128.5,170.5C 128.759,172.989 127.759,174.656 125.5,175.5C 126.541,172.609 127.874,169.942 129.5,167.5 Z"
      />
    </g>
    <g>
      <path
        fill="#c8f2f0"
        d="M 167.5,170.5 C 167.662,172.527 167.495,174.527 167,176.5C 165.643,179.686 164.143,182.686 162.5,185.5C 163.609,180.173 165.275,175.173 167.5,170.5 Z"
      />
    </g>
    <g>
      <path
        fill="#97e5e2"
        d="M 88.5,161.5 C 89.6533,167.653 89.82,173.986 89,180.5C 82.4013,181.826 75.9013,181.826 69.5,180.5C 75.69,180.823 81.69,180.49 87.5,179.5C 88.4896,173.69 88.8229,167.69 88.5,161.5 Z"
      />
    </g>
    <g>
      <path
        fill="#a6e9e7"
        d="M 125.5,178.5 C 125.573,180.027 124.906,181.027 123.5,181.5C 123.427,179.973 124.094,178.973 125.5,178.5 Z"
      />
    </g>
    <g>
      <path
        fill="#b7edec"
        d="M 122.5,185.5 C 121.962,187.117 121.629,188.784 121.5,190.5C 121.167,190.5 120.833,190.5 120.5,190.5C 120.12,188.302 120.787,186.635 122.5,185.5 Z"
      />
    </g>
    <g>
      <path
        fill="#b5edeb"
        d="M 162.5,185.5 C 162.771,187.38 162.104,188.713 160.5,189.5C 160.66,187.847 161.326,186.514 162.5,185.5 Z"
      />
    </g>
    <g>
      <path
        fill="#90e5e3"
        d="M 160.5,189.5 C 160.5,190.833 160.5,192.167 160.5,193.5C 159.5,194.167 158.5,194.833 157.5,195.5C 158.508,193.456 159.508,191.456 160.5,189.5 Z"
      />
    </g>
    <g>
      <path
        fill="#2ccfca"
        d="M 93.5,192.5 C 96.5184,192.335 99.5184,192.502 102.5,193C 103.056,193.383 103.389,193.883 103.5,194.5C 105.181,197.582 105.848,200.915 105.5,204.5C 104.167,205.167 103.167,206.167 102.5,207.5C 99.4648,208.734 96.4648,208.734 93.5,207.5C 92.5084,207.672 91.8417,207.338 91.5,206.5C 91.4431,205.391 91.1098,204.391 90.5,203.5C 90.448,201.097 90.7814,198.764 91.5,196.5C 92.6005,195.395 93.2671,194.062 93.5,192.5 Z"
      />
    </g>
    <g>
      <path
        fill="#d4f4f3"
        d="M 93.5,192.5 C 93.2671,194.062 92.6005,195.395 91.5,196.5C 90.8826,196.611 90.3826,196.944 90,197.5C 89.5045,199.473 89.3379,201.473 89.5,203.5C 87.3928,198.613 88.7261,194.946 93.5,192.5 Z"
      />
    </g>
    <g>
      <path
        fill="#aeecea"
        d="M 103.5,194.5 C 104.496,194.414 105.329,194.748 106,195.5C 106.805,198.696 106.638,201.696 105.5,204.5C 105.848,200.915 105.181,197.582 103.5,194.5 Z"
      />
    </g>
    <g>
      <path
        fill="#bdefed"
        d="M 160.5,193.5 C 159.109,195.921 158.275,198.588 158,201.5C 157.329,202.252 156.496,202.586 155.5,202.5C 155.878,200.079 156.545,197.746 157.5,195.5C 158.5,194.833 159.5,194.167 160.5,193.5 Z"
      />
    </g>
    <g>
      <path
        fill="#a9eae7"
        d="M 118.5,197.5 C 118.573,199.027 117.906,200.027 116.5,200.5C 116.427,198.973 117.094,197.973 118.5,197.5 Z"
      />
    </g>
    <g>
      <path
        fill="#8de3e1"
        d="M 91.5,196.5 C 90.7814,198.764 90.448,201.097 90.5,203.5C 90.1667,203.5 89.8333,203.5 89.5,203.5C 89.3379,201.473 89.5045,199.473 90,197.5C 90.3826,196.944 90.8826,196.611 91.5,196.5 Z"
      />
    </g>
    <g>
      <path
        fill="#61dbd8"
        d="M 120.5,190.5 C 120.833,190.5 121.167,190.5 121.5,190.5C 120.593,195.528 118.926,200.195 116.5,204.5C 116.5,204.167 116.5,203.833 116.5,203.5C 116.5,202.5 116.5,201.5 116.5,200.5C 117.906,200.027 118.573,199.027 118.5,197.5C 118.4,194.892 119.067,192.558 120.5,190.5 Z"
      />
    </g>
    <g>
      <path
        fill="#c9f2f1"
        d="M 89.5,203.5 C 89.8333,203.5 90.1667,203.5 90.5,203.5C 91.1098,204.391 91.4431,205.391 91.5,206.5C 90.0937,206.027 89.427,205.027 89.5,203.5 Z"
      />
    </g>
    <g>
      <path
        fill="#a2e8e6"
        d="M 116.5,203.5 C 116.5,203.833 116.5,204.167 116.5,204.5C 116.167,205.5 115.5,206.167 114.5,206.5C 114.427,204.973 115.094,203.973 116.5,203.5 Z"
      />
    </g>
    <g>
      <path
        fill="#abeae8"
        d="M 105.5,204.5 C 105.5,206.5 104.5,207.5 102.5,207.5C 103.167,206.167 104.167,205.167 105.5,204.5 Z"
      />
    </g>
    <g>
      <path
        fill="#b3ecea"
        d="M 155.5,204.5 C 155.771,206.38 155.104,207.713 153.5,208.5C 153.66,206.847 154.326,205.514 155.5,204.5 Z"
      />
    </g>
    <g>
      <path
        fill="#a3e9e7"
        d="M 93.5,207.5 C 96.4648,208.734 99.4648,208.734 102.5,207.5C 102.389,208.117 102.056,208.617 101.5,209C 100.167,209.167 98.8333,209.333 97.5,209.5C 95.6672,209.415 94.3339,208.748 93.5,207.5 Z"
      />
    </g>
    <g>
      <path
        fill="#afebea"
        d="M 113.5,210.5 C 112.962,212.117 112.629,213.784 112.5,215.5C 112.167,215.5 111.833,215.5 111.5,215.5C 111.12,213.302 111.787,211.635 113.5,210.5 Z"
      />
    </g>
    <g>
      <path
        fill="#65dbd8"
        d="M 150.5,215.5 C 150.371,217.216 150.038,218.883 149.5,220.5C 148.985,222.751 147.985,224.751 146.5,226.5C 146.649,222.282 147.983,218.615 150.5,215.5 Z"
      />
    </g>
    <g>
      <path
        fill="#d1f4f2"
        d="M 153.5,211.5 C 153.657,212.873 153.49,214.207 153,215.5C 152.263,217.596 151.097,219.263 149.5,220.5C 150.038,218.883 150.371,217.216 150.5,215.5C 151.026,213.77 152.026,212.436 153.5,211.5 Z"
      />
    </g>
    <g>
      <path
        fill="#a4e9e6"
        d="M 109.5,222.5 C 109.573,224.027 108.906,225.027 107.5,225.5C 107.427,223.973 108.094,222.973 109.5,222.5 Z"
      />
    </g>
    <g>
      <path
        fill="#cff3f2"
        d="M 149.5,220.5 C 149.662,222.527 149.495,224.527 149,226.5C 147.951,229.187 146.451,231.52 144.5,233.5C 145.455,231.254 146.122,228.921 146.5,226.5C 147.985,224.751 148.985,222.751 149.5,220.5 Z"
      />
    </g>
    <g>
      <path
        fill="#5bdad7"
        d="M 111.5,215.5 C 111.833,215.5 112.167,215.5 112.5,215.5C 111.593,220.528 109.926,225.195 107.5,229.5C 107.5,229.167 107.5,228.833 107.5,228.5C 107.5,227.5 107.5,226.5 107.5,225.5C 108.906,225.027 109.573,224.027 109.5,222.5C 109.4,219.892 110.067,217.558 111.5,215.5 Z"
      />
    </g>
    <g>
      <path
        fill="#e2f7f6"
        d="M 205.5,230.5 C 203.097,230.448 200.764,230.781 198.5,231.5C 198.5,230.5 198.5,229.5 198.5,228.5C 201.388,227.99 203.721,228.656 205.5,230.5 Z"
      />
    </g>
    <g>
      <path
        fill="#9ee7e5"
        d="M 107.5,228.5 C 107.5,228.833 107.5,229.167 107.5,229.5C 107.167,230.5 106.5,231.167 105.5,231.5C 105.427,229.973 106.094,228.973 107.5,228.5 Z"
      />
    </g>
    <g>
      <path
        fill="#88e3e0"
        d="M 198.5,231.5 C 198.975,234.313 197.975,236.313 195.5,237.5C 196.508,235.456 197.508,233.456 198.5,231.5 Z"
      />
    </g>
    <g>
      <path
        fill="#9fe7e6"
        d="M 144.5,235.5 C 144.5,237.5 143.5,238.5 141.5,238.5C 142.167,237.167 143.167,236.167 144.5,235.5 Z"
      />
    </g>
    <g>
      <path
        fill="#d7f5f4"
        d="M 205.5,232.5 C 208.198,236.616 209.198,241.283 208.5,246.5C 208.167,246.5 207.833,246.5 207.5,246.5C 207.5,245.167 207.5,243.833 207.5,242.5C 207.946,239.99 207.28,237.99 205.5,236.5C 205.5,235.167 205.5,233.833 205.5,232.5 Z"
      />
    </g>
    <g>
      <path
        fill="#a3ebe9"
        d="M 104.5,235.5 C 104.5,236.5 104.5,237.5 104.5,238.5C 116.833,238.5 129.167,238.5 141.5,238.5C 129.007,239.66 116.34,239.827 103.5,239C 102.015,237.244 102.348,236.077 104.5,235.5 Z"
      />
    </g>
    <g>
      <path
        fill="#a4e8e6"
        d="M 205.5,236.5 C 207.28,237.99 207.946,239.99 207.5,242.5C 205.926,240.898 205.259,238.898 205.5,236.5 Z"
      />
    </g>
    <g>
      <path
        fill="#8ce4e1"
        d="M 194.5,238.5 C 194.762,239.978 194.429,241.311 193.5,242.5C 192.012,244.967 190.346,247.3 188.5,249.5C 189.379,245.171 191.379,241.504 194.5,238.5 Z"
      />
    </g>
    <g>
      <path
        fill="#39d2cd"
        d="M 205.5,230.5 C 205.5,231.167 205.5,231.833 205.5,232.5C 205.5,233.833 205.5,235.167 205.5,236.5C 205.259,238.898 205.926,240.898 207.5,242.5C 207.5,243.833 207.5,245.167 207.5,246.5C 207.5,249.167 207.5,251.833 207.5,254.5C 206.5,254.5 205.5,254.5 204.5,254.5C 204.461,253.417 204.127,252.417 203.5,251.5C 199.5,250.167 195.5,250.167 191.5,251.5C 190.807,252.518 190.141,253.518 189.5,254.5C 187.153,253.393 186.82,251.726 188.5,249.5C 190.346,247.3 192.012,244.967 193.5,242.5C 194.429,241.311 194.762,239.978 194.5,238.5C 195.167,238.5 195.5,238.167 195.5,237.5C 197.975,236.313 198.975,234.313 198.5,231.5C 200.764,230.781 203.097,230.448 205.5,230.5 Z"
      />
    </g>
    <g>
      <path
        fill="#88e2e0"
        d="M 198.5,240.5 C 197.37,242.315 196.704,244.315 196.5,246.5C 198.5,246.5 200.5,246.5 202.5,246.5C 199.976,247.8 197.309,247.8 194.5,246.5C 194.932,243.819 196.266,241.819 198.5,240.5 Z"
      />
    </g>
    <g>
      <path
        fill="#e4f8f7"
        d="M 202.5,242.5 C 202.5,243.833 202.5,245.167 202.5,246.5C 200.5,246.5 198.5,246.5 196.5,246.5C 196.704,244.315 197.37,242.315 198.5,240.5C 199.15,240.196 199.817,239.863 200.5,239.5C 201.176,240.602 201.842,241.602 202.5,242.5 Z"
      />
    </g>
    <g>
      <path
        fill="#b1ecea"
        d="M 202.5,242.5 C 201.842,241.602 201.176,240.602 200.5,239.5C 199.817,239.863 199.15,240.196 198.5,240.5C 198.712,238.616 199.712,237.283 201.5,236.5C 202.466,238.396 202.799,240.396 202.5,242.5 Z"
      />
    </g>
    <g>
      <path
        fill="#bfefed"
        d="M 204.5,254.5 C 202.952,254.179 202.285,253.179 202.5,251.5C 199.167,251.5 195.833,251.5 192.5,251.5C 192.912,253.973 191.912,255.306 189.5,255.5C 189.5,255.167 189.5,254.833 189.5,254.5C 190.141,253.518 190.807,252.518 191.5,251.5C 195.5,250.167 199.5,250.167 203.5,251.5C 204.127,252.417 204.461,253.417 204.5,254.5 Z"
      />
    </g>
    <g>
      <path
        fill="#94e5e3"
        d="M 207.5,246.5 C 207.833,246.5 208.167,246.5 208.5,246.5C 209.008,249.176 209.175,251.843 209,254.5C 207.384,255.801 205.884,255.801 204.5,254.5C 205.5,254.5 206.5,254.5 207.5,254.5C 207.5,251.833 207.5,249.167 207.5,246.5 Z"
      />
    </g>
    <g>
      <path
        fill="#8de4e1"
        d="M 188.5,249.5 C 186.82,251.726 187.153,253.393 189.5,254.5C 189.5,254.833 189.5,255.167 189.5,255.5C 188.167,255.5 186.833,255.5 185.5,255.5C 185.433,254.041 185.766,252.708 186.5,251.5C 186.5,250.167 187.167,249.5 188.5,249.5 Z"
      />
    </g>
    <g>
      <path
        fill="#d7f5f3"
        d="M 186.5,251.5 C 185.766,252.708 185.433,254.041 185.5,255.5C 186.833,255.5 188.167,255.5 189.5,255.5C 188.365,257.213 186.698,257.88 184.5,257.5C 184.025,254.918 184.692,252.918 186.5,251.5 Z"
      />
    </g>
  </svg>
);
export default Vungle;
